import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Button, Checkbox, ConfigProvider, message, Modal} from "antd";
import {t} from "i18next";
import {isStringNullOrEmpty} from "../../utils";
import {IMPORT_FILE_MODE_IMPORTMODE, MAX_Z_INDEX} from "../../Const";
import {ipcInvoke} from "../../common/ipc";
import {updateTranscript} from "@model/transcript";

const DialogReplace = forwardRef((props:{onCloseCallback:any}, ref) => {
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog
    }))
    const [isShowDialog, setIsShowDialog] = useState(false);
    const inputFindRef = useRef(null);
    const inputReplaceRef = useRef(null);
    const [searchResult,setSearchResult] = useState('');
    const [searchKey,setSearchKey] = useState('');
    const mTranscriptRef = useRef<any>(null);
    const mCallback = useRef<any>(null);
    const mSearchKey = useRef<any>('');

    const onShowDialog = (searchKey,transcript,callback)=>{
        setIsShowDialog(true);
        mTranscriptRef.current = transcript;
        mCallback.current = callback;
        setSearchKey(searchKey);
        mSearchKey.current = searchKey;
        onSearch();

        setTimeout(()=>{
            inputFindRef.current?.focus();
        },200)
    }

    const onSearch = ()=>{
        if (!mSearchKey.current) {
            setSearchResult('');
            return;
        };

        const szLowerCase = mSearchKey.current?.toLowerCase()?.trim();
        const arrayFilters = mTranscriptRef.current?.data.filter(p=>p.content?.toLowerCase().includes(szLowerCase));
        if (arrayFilters.length == 0){
            setSearchResult(t('No found'))
        }else{
            setSearchResult(t('Results found').replace('{0}',arrayFilters.length));
        }
    }

    return <Modal width={360} zIndex={MAX_Z_INDEX} bodyStyle={{}}
                  styles={{
                      content: {
                          padding:'16px 16px'
                      }
                  }}
                  afterClose={() => {
                      props.onCloseCallback();
                  }}
                  open={isShowDialog} centered={true} closable={false} closeIcon={<IconClose/>} footer={null}
                  onCancel={() => {
                      setIsShowDialog(false)
                  }}>
        <div className={'default-font-size default-font-family'} style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
            {/*<div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>*/}
            {/*    <span className={'dialog-title'}>{''}</span>*/}
            {/*    <div style={{flexGrow: '1'}}/>*/}
            {/*</div>*/}
            {/*<div className={'line mt-12'} style={{margin: '12px -22px'}}></div>*/}
            <span>{t('Find')}</span>
            <div className={'flex-row-vertical-center input-border mt-4'}>
                <input ref={inputFindRef} value={searchKey} className={'no-border'} style={{flexGrow:'1'}} onInput={(e)=>{
                    setSearchKey(e.currentTarget.value);
                    mSearchKey.current = e.currentTarget.value;
                    onSearch();
                }}/>
                {
                    searchResult &&
                    <span>{searchResult}</span>
                }
            </div>


            <span className={'mt-16'}>{t('Replace with')}</span>
            <input ref={inputReplaceRef} className={'input-border mt-4'}/>

            <div className={'flex-center mt-32 mb-4'}>
                <Button
                    // disabled={isStringNullOrEmpty(selectFile)}
                    className='large-w-button button-solid-style font-size-14 font-family-medium'
                    type="primary"
                    onClick={async () => {
                        if (searchKey && inputReplaceRef.current?.value) {
                            const szLowerCase = searchKey.toLowerCase();
                            const newData = [...mTranscriptRef.current?.data];
                            const arrayFilters = newData.filter(p=>p.content?.toLowerCase().includes(szLowerCase));
                            arrayFilters.forEach(p=>{
                                p.content = p.content.replaceAll(searchKey,inputReplaceRef.current?.value);
                            })
                            const newTranscript = {...mTranscriptRef.current};
                            newTranscript.data = newData;
                            props.onCloseCallback();
                            //保存..
                            updateTranscript(newTranscript).then(res=>{
                                mCallback.current(newTranscript);
                            });
                        }
                    }}
                    style={{
                        minWidth: '100%'
                    }}
                    htmlType={"submit"}>{t("ReplaceAll0")}</Button>
            </div>
        </div>
    </Modal>
})

export default DialogReplace;

















